export default __webpack_public_path__ + "static/media/dehasoft-robot-kafasi.9969c578.png";